import React from "react";
import Imagen from "../../images/modulo13/dondevivimosdialogos.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo13 } from "../../routes/Module13";
import { modulo14 } from "../../routes/Module14";

import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";

const Modulo1Conclusion = () => {
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo13.content[0].name} - ${modulo13.content[0].activities[10].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[10].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title}`,
    name: modulo13.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Entonces, ¿quiénes s omos los peruanos?</h1>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que observen con detenimiento la imagen presentada. Elabore
            algunas preguntas y respóndalas conjuntamente:
            <ul>
              <li>
                <i>
                  “¿Qué información ofrece el mapa? (Posible respuesta: El mapa
                  está dividido en tres regiones: costa, sierra y selva. Muestra
                  los diversos recursos naturales de cada región y además
                  algunos de los problemas que se enfrentan en cada parte del
                  territorio).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué recursos vemos en cada una de las regiones? (Posible
                  respuesta: En la costa vemos algodón, espárragos, algunas
                  frutas, petróleo y los recursos marítimos. En la sierra, vemos
                  papas, maíz, habas, ganado, minerales, cordilleras y
                  glaciares. En la selva, vemos café, cacao, madera, ríos y
                  petróleo).
                </i>
              </li>
              <li>
                <i>
                  ¿Cuál es el problema principal en cada una de las regiones?
                  (Posible respuesta: En la costa, se observa una nube de
                  contaminación encima de Lima. En la sierra, vemos glaciares
                  derritiéndose. En la selva, observamos lluvias extremas)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Otorgue los roles de los personajes que aparecen en la imagen al
            niño o a la niña y pídale que lean en voz alta. Formule las
            siguientes preguntas:
            <ul>
              <li>
                <i>
                  “¿De qué problema están hablando los personajes? (Posible
                  respuesta: De los problemas que afectan nuestro territorio
                  como consecuencia del cambio climático).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué soluciones se plantean ante este problema? (Posible
                  respuesta: La protección del territorio y el involucramiento
                  de autoridades y ciudadanos para tomar acciones que
                  contrarresten la contaminación ambiental)”.
                </i>
              </li>
            </ul>
          </li>
          <li>
            Señale que a lo largo de la unidad de ha trabajado la convivencia,
            la deliberación y la participación. Resalte cómo se relaciona la
            imagen con estas capacidades, por ejemplo:
            <ul>
              <li>
                <i>
                  “La convivencia con nuestro entorno ha traído varios retos
                  para que las personas puedan adaptarse a una geografía tan
                  variada como la de nuestro país. De un lado, tenemos los
                  problemas derivados del cambio climático que afectan muchos de
                  nuestros recursos naturales. De otro lado, muchas acciones del
                  ser humano (extracción de recursos, el crecimiento de las
                  ciudades, etc.) ponen en peligro dichos recursos. Ante esto,
                  es importante mantenernos informados sobre los problemas que
                  perjudican nuestro territorio, así como escuchar las distintas
                  posiciones que las personas tienen sobre un mismo problema y
                  deliberar al respecto. También es importante tomar acción y
                  participar de las decisiones que ayuden a conservar y proteger
                  nuestro entorno”.
                </i>
              </li>
            </ul>
          </li>
          <li>
            Ahora retome la pregunta principal: Entonces, ¿dónde vivimos los
            peruanos? Para responderla, guíe la discusión:
            <ul>
              <li>
                <i>¿Es nuestro territorio homogéneo o diverso?</i>
              </li>
              <li>
                <i>
                  ¿Qué problemas y ventajas trae la diversidad del territorio?
                </i>
              </li>
              <li>
                <i>
                  ¿Cómo es la relación que las personas establecen con el
                  territorio?
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo14.url}>
          <button className={`btn btn-${modulo13.color} me-2`}>
            {modulo14.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1Conclusion;
